import React from 'react';
import md5 from 'md5';
import './CompetitionTopListWidget.scss';

const CompetitionTopListWidget = (props) => {
    if (props.isThumbnail) {
        return (<div className="table" />);
    } else {
        return newRender(props);
    }
};

const newRender = (props) => {
    const { slide, widget, widgetData } = props;
    const customTextColor = slide ? slide.custom.bgColor : companyProfile.colors.mainBg;

    const starSpanStyle = { textAlign: "right", color: props.slide.custom.bgColor };
    const todaysScoreStyle = { color: "#747474", fontFamily: 'Roboto', display: 'inline-block', paddingLeft: "5px", paddingRight: "0px", paddingBottom: "5px" };

    // Always fill the table with at least one row to get the header to not be in the middle.
    const defaultWidgetData = widgetData && widgetData.length ? widgetData : [];

    if (!defaultWidgetData.length) {
        return (
            <div className="loading">
                Loading
                <i className="fa fa-refresh fa-spin fa-fw" aria-hidden="true" />
            </div>
        );
    }

    let shortenedWidgetData;
	const sortedWidgetData = _.orderBy(defaultWidgetData, ['totalScore'], ['desc']);
    
    if (widget.height < 11) {
        shortenedWidgetData = _.take(sortedWidgetData, 5);
    } else if (widget.height < 16) {
        shortenedWidgetData = _.take(sortedWidgetData, 10);
    } else {
        shortenedWidgetData = sortedWidgetData;
    }

    //sort by totalScore and add serial number
    shortenedWidgetData.forEach((row, i) => row['#'] = ++i);

    const columnss = ['#', 'email', 'name', 'todaysScore', 'totalScore'];
    let rows = shortenedWidgetData.map(row =>
        columnss.reduce((result, column) =>
            Object.assign({}, result, { [column]: _.get(row, column) }), {}));

    //get max score and find out the matching 
    //records to append a star to them
    const bestOfToday = getBestOfTodayList(rows);

    let adjustedHeight;
    let adjustedWidth;
    if (rows.length === 10) {
        adjustedHeight = "42px";
        adjustedWidth = "42px";
    }

    const table = rows.map((row, i) => {
        const columns = _.map(row, (value, index) => {
            if (index === 'todaysScore' || index === 'totalScore') {
                if (index === 'todaysScore' && _.includes(bestOfToday, value)) { //if exists in best score, add a star to it
                    return <span className="fa fa-star" style={starSpanStyle} key={index}><span style={todaysScoreStyle}>{value}</span></span>;
                }
                //total score and todays score should be aligned right
                return <span key={index} style={{ textAlign: 'right' }}>{value}</span>;

            } else if (index === 'name') { //add avatar
                let initials = getInitials(value);
                let hash = md5(row.email);

                return (
                    <span key={index}>
                        <span style={{ height: adjustedHeight, width: adjustedWidth }}>
                            <div className="user-holder">
                                <div title={value} className="userImage" style={{ background: customTextColor }}>
                                    <div className="topscore-initials">
                                        {initials}
                                    </div>
                                    <div style={{ position: "absolute" }}><img src={`//gravatar.com/avatar/${hash}?size=100&d=blank&r=x`} className="avatar" alt={value} /></div>
                                </div>
                            </div>
                        </span>
                        <span>
                            <span style={{ paddingLeft: "5px" }}>{value}</span>
                        </span>
                    </span>);

            } else if (index === '#') { //for serial number just apply padding
                return <span key={index} style={{ paddingLeft: "25px" }}>{value}</span>;
            }
        });

        return (
            <li className='' key={i}>
                {columns}
            </li>
        );
    });

    //create the headers
    const columns = ['#', 'USERS', 'TODAY', 'TOTAL SCORE'];
    const headers = columns.map(column => {
        if (column === 'TOTAL SCORE' || column === 'TODAY') {
            return <span style={{ textAlign: 'right' }} key={column}>{column}</span>
        }

        return <span key={column}>{column}</span>
    });

    let title = widget.displayConfig.customTitle;
    return (
        <div className="table">
            <h4 className='widget_title' style={{ color: '#1E252E', fontSize: '36px', height: '43px', fontWeight: '400', lineHeight: '43px' }} >{title}</h4>
            <ul className="table-row">
                <li className="table-head">
                    {headers}
                </li>
                {table}
            </ul>
        </div >
    );
};

function getBestOfTodayList(rows) {
    const maxScore = _.maxBy(rows, 'todaysScore');
    const bestOfTodayList = _.filter(rows, row => row.todaysScore === maxScore.todaysScore);

    let justScores = bestOfTodayList.map(best => best.todaysScore);
    return justScores;
}

function getInitials(user) {
    if (!user) {
        return '';
    }

    let i1 = '';
    let i2 = '';
    let nameArray = [];

    if (user) {
        i1 = user.charAt(0);
        nameArray = user.split(' ');

        if (nameArray.length > 2) {
            i2 = nameArray[nameArray.length - 1].charAt(0);
        } else if (nameArray.length === 2) {
            i2 = nameArray[1].charAt(0);
        }
    }

    return i1 + i2;
}

CompetitionTopListWidget.propTypes = {
    widgetData: React.PropTypes.array,
};

export default CompetitionTopListWidget;



/** WEBPACK FOOTER **
 ** ./client/components/Widgets/CompetitionWidgets/CompetitionTopListWidget.jsx
 **/